<template>
    <el-row id="collection">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnSave="true" :btnBack="true" @btnSaveClick="btnSaveClick"
            @btnBackClick="btnBackClick" />
        <el-form label-width="120px" :model="uploadTaskForm" ref="ruleForm" id="ruleForm" hide-required-asterisk>
            <el-row>
                <el-col :span="24" style="position: relative;margin-top: 30px">
                    <el-form-item label="任务名称" prop="task_name" :rules="[
                                           { required: true, message: '任务名称不能为空'},]" class="collection_star">
                        <el-input type="text" v-model="uploadTaskForm.task_name" placeholder="请输入任务名称"
                            style="width: calc(100% - 90px)">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="text-align: left;margin-top:20px;width: calc(100% - 90px)">


                    <el-form-item label="任务日期" prop="start_date" :rules="[
                                           { required: true, message: '任务日期不能为空'},]" class="collection_star">
                        <el-col :span="11">
                            <el-form-item prop="start_date" :rules="[
                                           { required: true, message: '任务日期不能为空'},]" class="collection_star">
                                <el-date-picker v-model="uploadTaskForm.start_date" type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" style="width:100%" placeholder="选择日期"
                                    @change="chooseTimeRange0">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" style="text-align: center">
                            至
                        </el-col>
                        <el-col :span="11">
                            <el-form-item prop="end_date" :rules="[
                                           { required: true, message: '任务日期不能为空'},]" class="collection_star">
                                <el-date-picker v-model="uploadTaskForm.end_date" type="datetime" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm"  placeholder="选择日期" style="width:100%"
                                    @change="chooseTimeRange2">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                    </el-form-item>

                </el-col>
                <el-col :span="24" style="text-align: left;margin-top:20px;">
                    <el-form-item label="采集辖区" prop="territory_id" :rules="[
                                           { required: true, message: '采集辖区不能为空'},]" class="collection_star">
                        <el-cascader v-model="uploadTaskForm.territory_id" :options="territoryList"
                            :props="{ multiple: true, checkStrictly: true }" :show-all-levels="false"
                            style="width: calc(100% - 90px)" clearable>
                        </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="text-align: left;margin-top:20px;">
                    <el-form-item label="采集对象" prop="reference_obj" :rules="[
                                           { required: true, message: '采集对象不能为空'},]" class="collection_star">
                        <el-select v-model="uploadTaskForm.reference_obj" multiple filterable placeholder="请选择"  @change="selectRefreenceObj()"
                            style="width: calc(100% - 90px)">
                            <el-option v-for="item in collectObject" :key="item.id" :label="item.value"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="text-align: left;margin-top:20px;">
                    <el-form-item label="采集对象模板" prop="template_id" :rules="[
                                           { required: true, message: '采集对象模板不能为空'},]" class="collection_star">
                        <el-select v-model="uploadTaskForm.template_id" filterable placeholder="请选择"
                            style="width: calc(100% - 90px)">
                            <el-option v-for="item in groupList" :key="item.group_id" :label="item.label"
                                :value="item.group_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="text-align: left;margin-top:20px;">
                    <el-form-item label="状态">
                        <template>
                            <el-radio v-model="uploadTaskForm.radio" label="DRAFT">未发布</el-radio>
                            <el-radio v-model="uploadTaskForm.radio" label="PUBLISH">已发布</el-radio>
                            <el-radio v-model="uploadTaskForm.radio" label="CLOSED">已完成/关闭</el-radio>
                        </template>
                        <p style="margin:0;font-size: 12px;color: #9B9B9B">如需要提前结束采集任务，可将状态设置为"已完成/关闭"</p>
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>

    </el-row>
</template>

<script>
    import collectionBar from '../../../components/collectionBar'
    import http from '../../../APIService/http'
    import jurisdiction from '../../../assets/images/jurisdiction.png'
    import jurisdiction2 from '../../../assets/images/jurisdiction2.png'
    import moment from "moment";

    export default {
        name: "taskProfile",
        data() {
            return {
                tags: ['数据采集任务', '任务概要'],
                subTitle: '',
                collectObject: [
                    {
                        id: 'HCP',
                        value: 'HCP'
                    }, {
                        id: 'INSTITUTION',
                        value: '机构'
                    }, {
                        id: 'RETAILSTORE',
                        value: '门店'
                    }, {
                        id: 'DISTRIBUTOR',
                        value: '经销商'
                    }, {
                        id: 'CUSTOMTABLE',
                        value: '自定义表格'
                    },
                ],
                uploadTaskForm: {
                    task_name: '',
                    task_id: '',
                    start_date: '',
                    end_date: '',
                    territory_id: [],
                    reference_obj: [],
                    template_id: "",
                    radio: ''
                },

                territory_name: '',

                mineStatusValue: '',
                territoryList: [],
                groupList: [],
                icon: [jurisdiction, jurisdiction2],
                collectProfile: [],


            }
        },


        components: {
            collectionBar,
        },
        created() {
            console.log(this.$route.params)
            if (this.$route.params.task_id) {
                this.uploadTaskForm.task_id = this.$route.params.task_id
                this.collectProfile = JSON.stringify(this.$route.params)
                localStorage.setItem('collectProfile', this.collectProfile)
            } else {
                this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
                this.uploadTaskForm.task_id = this.collectProfile.task_id
            }

            this.territoryList = JSON.parse(localStorage.getItem('territoryList')) ? JSON.parse(localStorage.getItem('territoryList')) : []
            if (this.territoryList.length == 0) {
                this.getTerritoryList()
            }
            this.init()

        },
        methods: {
            btnSaveClick() {
                this.$refs["ruleForm"].validate(valid => {
                    if (!valid) {
                        return false
                    } else {
                        this.updateTaskList()
                    }
                })


            },
            btnBackClick() {
                this.$router.push({ name: 'CollectionHome' })
            },
            handleNodeClick() {

            },
            init() {
                let loading2 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.uploadTaskForm.task_id
                    }
                    http.post('/wapi/Collect/getCollectInfo', data).then(res => {
                        if (res.success == true) {
                            console.log(res.data)
                            this.subTitle = res.data[0].task_name
                            this.uploadTaskForm.task_name = res.data[0].task_name
                            this.uploadTaskForm.start_date = res.data[0].start_date
                            this.uploadTaskForm.end_date = res.data[0].end_date
                            this.uploadTaskForm.territory_id = res.data[0].territory_id
                            this.uploadTaskForm.reference_obj = res.data[0].reference_obj
                            this.uploadTaskForm.template_id = res.data[0].template_id
                            this.uploadTaskForm.radio = res.data[0].status=="COPYING"?"DRAFT":res.data[0].status
                            this.getGroupList()
                        }

                        loading2.close()

                    })
                } catch (e) {
                    loading2.close()
                }

            },

        selectRefreenceObj(e){
            console.log(e)
            this.getGroupList()
        },
        async getGroupList() {
            try {
                let user = this.$store.getters.getUser

                this.groupList = []
                for (const item of this.uploadTaskForm.reference_obj) {
                    let data = {
                        tenant_id: user.tenant_id,
                        reference_obj: item
                    }
                    await http.post('/wapi/Collect/getCollectField', data).then(res => {
                        if (res.success) {
                            for (let i = 0; i < res.data.ary2.length; i++) {
                                this.groupList.push(res.data.ary2[i])
                            }
                        }
                    })
                }
            } catch (e) {
            }

        },
            chooseTimeRange0(t) {
                let time1 = moment(t).valueOf()
                let time2 = moment(this.uploadTaskForm.end_date).valueOf()
                if (time1 >= time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.uploadTaskForm.end_date = ''
                }

            },
            chooseTimeRange2(t) {

                let time1 = moment(t).valueOf()
                let time2 = moment(this.uploadTaskForm.start_date).valueOf()


                if (time1 < time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.uploadTaskForm.end_date = ''
                }
            },
            getTerritoryList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                    }
                    http.post('/wapi/Collect/getTerritoryList', data).then(res => {
                        if (res.success == true) {
                            console.log(res.data)
                            this.territoryList = res.data

                            localStorage.setItem('territoryList', JSON.stringify(this.territoryList))

                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }

            },


            updateTaskList() {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_name: this.uploadTaskForm.task_name,
                        task_id: this.uploadTaskForm.task_id,
                        start_date: this.uploadTaskForm.start_date,
                        end_date: this.uploadTaskForm.end_date,
                        territory_id: this.uploadTaskForm.territory_id,
                        reference_obj: this.uploadTaskForm.reference_obj,
                        template_id: this.uploadTaskForm.template_id,
                        status: this.uploadTaskForm.radio
                    }

                    http.post('/wapi/Collect/updateTaskList', data).then(res => {
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: "保存成功"
                            })
                            this.subTitle = this.uploadTaskForm.task_name
                            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
                            localStorage.removeItem('collectProfile')
                            this.collectProfile.task_name = this.uploadTaskForm.task_name

                            let collectProfile = JSON.stringify(this.collectProfile)
                            localStorage.setItem('collectProfile', collectProfile)



                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }


            },

        },

    }
</script>

<style scoped>
    #collection>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }

    #collection>>>.el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #collection>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
    }

    #collection>>>.collection_star label:after {
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/taskProfile.vue